export default __webpack_public_path__ + "static/media/box.affc64b9.jpg";